import React from "react";
import PropTypes from "prop-types";

import { flattenAddress } from "../../../utils/address";

// Lien Google Maps « itinéraire point par point » d'une tournée : dépôt (centre) → arrêts dans l'ordre de
// passage. Coordonnées tirées des tasks natives (lat/lng), repli sur l'adresse texte. Mode voiture.
// Voies rapides évitées UNIQUEMENT pour Paris intramuros (scooter interdit de périphérique) — la
// banlieue (voiture) garde l'itinéraire normal. `avoidHighways` explicite (zone connue), sinon déduit
// des codes postaux (tournée 100 % 75xxx). Partagé par la simulation et le dry-run.
export function DockMapsLink({ orders, tasks, depot, avoidHighways }) {
  const intramuros =
    avoidHighways !== undefined
      ? avoidHighways
      : (orders || []).length > 0 &&
        (orders || []).every((o) => (o.postal_code || "").startsWith("75"));
  const point = (a) =>
    (a && a.latitude && a.longitude)
      ? `${a.latitude},${a.longitude}`
      : (a ? flattenAddress(a).replace(/ /g, "+") : null);
  const stops = (orders || [])
    .map((o) => tasks && tasks[o.id] && point(tasks[o.id].address))
    .filter(Boolean);
  if (!stops.length) {
    return null;
  }
  const start = depot && depot.lat && depot.lng ? [`${depot.lat},${depot.lng}`] : [];
  const points = [...start, ...stops];
  // Format « Maps URLs » officiel : le seul qui accepte les options d'itinéraire (avoid=highways).
  const destination = points[points.length - 1];
  const waypoints = points.slice(0, -1);
  const url =
    "https://www.google.com/maps/dir/?api=1" +
    (waypoints.length ? `&origin=${encodeURIComponent(waypoints[0])}` : "") +
    (waypoints.length > 1 ? `&waypoints=${encodeURIComponent(waypoints.slice(1).join("|"))}` : "") +
    `&destination=${encodeURIComponent(destination)}` +
    "&travelmode=driving" +
    (intramuros ? "&avoid=highways" : "");
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" className="Sim-maps"
      title={intramuros
        ? "Itinéraire point par point depuis l'entrepôt (Google Maps, voies rapides évitées — scooter)."
        : "Itinéraire point par point depuis l'entrepôt (Google Maps, voiture)."}>
      <i className="fa-solid fa-route" /> maps
    </a>
  );
}
DockMapsLink.propTypes = {
  orders: PropTypes.array,
  tasks: PropTypes.object,
  depot: PropTypes.object,
  avoidHighways: PropTypes.bool,
};
